import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import escape from '../utils/escape';

import ListItemForTaskInput from './ListItemForTaskInput';
import { sortTasksByProjectAndTaskName } from '../utils/sorting';

import taskActions from '../actions/taskActionCreators';
import projectActions from '../actions/projectActionCreators';

require.ensure([], () => {
    require('./AutoTaskInput.less');
});

/*
 * Component for the automatic input of tasks. Each time a task is selected, it will
 * send a dispatch which will put the selected task in the store (in tasks.selectedTask).
 * Also, it will send another dispatch for the project of the selected task, and store
 * it into projects.selectedProject.
 *
 * Changing selected project in the store (for example, via AutoProjectInput) will make
 * this component only show tasks of this project. See componentWillReceiveProps method.
 *
 * If onlyTask prop is active, it will only select tasks and not send dispatches for
 * selected projects.
 */
class AutoTaskInput extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.tasks = this.props.tasks;
        if (this.props.filterByDate) this.tasks = this.tasks.filter(this.filterTasksByDate);
        if (this.props.hideArchived) this.tasks = this.tasks.filter(task => !task.projectArchived);
        if (this.props.hideClosed)   this.tasks = this.tasks.filter(task => !task.closed);

        let text = this.props.text ? this.props.text : "";
        let filteredTasks = this.tasks;

        if (this.props.fillTaskForLogEntry) {
            let selectedTask = this.props.fillTaskForLogEntry;
            text = selectedTask.name;
            filteredTasks = [selectedTask];
        }
        this.state = {
            blurTimeout: null,
            filteredTasks: filteredTasks,
            focused: false,
            forcePopup: this.props.forceInitialPopup,
            selectedIndex: 0,
            scrollTop: 0,
            tasks: this.tasks,
            text: text,
            width: 0
        };
    }

    // LIFECYCLE METHODS

    componentWillMount = () => {
        if (this.props.fillTaskForLogEntry) {
            let selectedProject = {}
            selectedProject.id = this.state.filteredTasks[0].projectID;
            selectedProject.name = this.state.filteredTasks[0].projectName;

            this.props.dispatch(taskActions.setSelectedTask(this.state.filteredTasks[0]));
            this.props.dispatch(projectActions.setSelectedProject(selectedProject));
        } else if (!this.props.onlyTask)
            this.props.dispatch(taskActions.setSelectedTask(null));
    }

    componentDidMount = () => {
        if (this.props.autoFocus) ReactDOM.findDOMNode(this.refs.taskField).focus();

        this.setState({
            popupWidth: ReactDOM.findDOMNode(this.refs.taskField).offsetWidth,
            popupLeft: ReactDOM.findDOMNode(this.refs.taskField).offsetLeft,
            popupTop: ReactDOM.findDOMNode(this.refs.taskField).offsetHeight + ReactDOM.findDOMNode(this.refs.taskField).offsetTop - 1
        });
    }

    //when the project is selected via AutoProjectInput, it will show only tasks of that selected project.
    componentWillReceiveProps = (nextProps) => {
        if(nextProps.clearInputs === true)
            this.clear();

        if (nextProps.selectedProject) {
            let tasks = nextProps.selectedProject ?  this.tasks.filter(task => task.projectID == nextProps.selectedProject.id) : this.tasks;
            this.setState({
                filteredTasks: tasks,
                tasks: tasks
            });
        } /*else if (nextProps.selectedProject === null) {
            let tasks = this.props.tasks;
                if (this.props.filterByDate) this.tasks = this.tasks.filter(this.filterTasksByDate);
                if (this.props.hideArchived) this.tasks = this.tasks.filter(task => !task.projectArchived);
                if (this.props.hideClosed)   this.tasks = this.tasks.filter(task => !task.closed);
            this.setState({
                filteredTasks: tasks,
                tasks: tasks,
                text: ""
            });
        }*/ else if (nextProps.tasks) {
            this.tasks = nextProps.tasks;
            if (this.props.filterByDate) this.tasks = this.tasks.filter(this.filterTasksByDate);
            if (this.props.hideArchived) this.tasks = this.tasks.filter(task => !task.projectArchived);
            if (this.props.hideClosed)   this.tasks = this.tasks.filter(task => !task.closed);

            let text = this.props.text ? this.props.text : "";
            let filteredTasks = this.tasks;

            this.setState({
                filteredTasks: this.tasks,
                tasks: this.tasks
            });
        }
        this.filterTasks(this.state.text);
    }

    componentWillUnmount = () => { clearTimeout(this.state.blurTimeout); }

    // EVENT HANDLERS

    handleBlur  = () => {
        this.setState({
            blurTimeout: setTimeout(() => {
                this.setState({
                    focused: false,
                    selectedIndex: 0,
                    forcePopup: false
                });
            }, 200)
        });
    }

    filterTasksByDate = (task) => {
        // if (this.props.isPmo) return true;

        //if (!task.assignedOn) return true;

        if (task.projectStartDate && this.props.filterByDate.format("YYYY-MM-DD") < task.projectStartDate) return false;

        if (task.projectEndDate && this.props.filterByDate.format("YYYY-MM-DD") > task.projectEndDate) return false;

        return true;
    }

    handleChange = (changeEvent) => {
        let text = changeEvent.target.value;

        this.props.dispatch(taskActions.setSelectedTask(null));
        this.setState({
            text: text,
            selectedIndex: 0,
            scrollTop: 0,
            focused: true,
            forcePopup: true
        });

        if (this.props.handleTextChange) {
            this.props.handleTextChange(text);
        }

        this.filterTasks(text);

        if (text === "") this.clear();
    }

    handleClick = () => { if (this.state.focused) this.setState({ forcePopup: true }); }

    handleFocus = () => {
        this.setState({
            focused: true,
            selectedIndex: 0
        });

        // we are going to show the popup so filter the tasks
        this.filterTasks(this.state.text);
    }

    handleKeyDown = (keyEvent) => {
        let newScrollTop = this.state.scrollTop;

        if (keyEvent.key === "Tab" && !this.props.disableTab && (this.state.selectedIndex == 0 && !(!this.state.text || this.state.text.trim() === ''))) {
            this.filterAndSetSelectedTask();
        } else if (keyEvent.key === "ArrowUp" && this.state.selectedIndex - 1 >= 0) {
            // calculate the new position by subtracing height of one item and then set it
            if (this.refs.popup) {
                newScrollTop = this.state.scrollTop - ReactDOM.findDOMNode(this.refs["item" + (this.state.selectedIndex - 1)]).scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            this.setState({
                selectedIndex: this.state.selectedIndex - 1,
                focused: true,
                scrollTop: newScrollTop
            });
        } else if (keyEvent.key === "ArrowDown" && this.state.selectedIndex + 1 < this.state.filteredTasks.length) {
            // calculate the new position by adding height of one item but watching that it doesn't go over max height
            if (this.refs.popup) {
                newScrollTop = this.state.scrollTop + ReactDOM.findDOMNode(this.refs["item" + (this.state.selectedIndex + 1)]).scrollHeight;
                let popupDOMNode = ReactDOM.findDOMNode(this.refs.popup);
                if (newScrollTop > popupDOMNode.scrollHeight) newScrollTop = popupDOMNode.scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            // filter tasks since we are gonna show the popup list
            let filter = new RegExp(escape.escapeInput(this.state.text), 'i');

            this.setState({
                selectedIndex: this.state.selectedIndex + 1,
                focused: true,
                scrollTop: newScrollTop,
                filteredTasks: this.state.tasks.filter( task => filter.test(task.name) || filter.test(task.projectName) || filter.test(task.alias) )
            });
        } else if (keyEvent.key === "Escape" && this.state.focused) {
            // don't close the create pill outside
            keyEvent.stopPropagation();

            this.setState({
                focused: false,
                forcePopup: false
            });
        }
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter") {
            this.filterAndSetSelectedTask();
            // if this would propagate it would close the form outside
            keyEvent.stopPropagation();
        }
    }

    handleMouseDown = (selectedIndex) => { this.setSelectedTask(selectedIndex); }

    handleMouseOver = (selectedIndex) => { this.setState({ selectedIndex: selectedIndex }); }

    handleScroll = () => {
        if (this.state.blurTimeout) {
            clearTimeout(this.state.blurTimeout);
            this.setState({ blurTimeout: null });
            ReactDOM.findDOMNode(this.refs.taskField).focus();
        }
    }

    // OTHER METHODS

    clear = () => {
        this.props.dispatch(taskActions.setSelectedTask(null));
        this.setState({
            filteredTasks: this.state.tasks,
            focused: false,
            forcePopup: false,
            selectedIndex: 0,
            scrollTop: 0,
            text: ""
        }, () => {
            if (this.props.handleTextChange) this.props.handleTextChange(this.state.text);
        });
    }

    filterAndSetSelectedTask = () => {
        if (this.state.filteredTasks.length === 1) {
            this.setSelectedTask(0);
        } else if (this.state.filteredTasks.length > 1) {
            this.setSelectedTask(this.state.selectedIndex);
        }
        //console.log('selected ', this.state.filteredTasks[this.state.selectedIndex]);
    }

    filterTasks (userInput, callbackAfterFilter) {
        if (userInput === '') {
            this.setState({ filteredTasks: this.state.tasks }
            , () => {
                if (callbackAfterFilter) callbackAfterFilter();
            });

            return;
        }

        let filter = new RegExp(escape.escapeInput(userInput), 'i');
        //console.log('filter', filter);

        this.setState({
            filteredTasks: this.state.tasks.filter(task => {
                if (this.props.selectedProject && !(this.props.selectedProject.name)) return true;

                // matches both task names and project names
                return filter.test(task.name) || filter.test(task.projectName) || filter.test(task.alias);
            })
        }, () => {
            if (callbackAfterFilter) callbackAfterFilter();
            //console.log('filter: ', filter);
            //console.log('filtered: ', this.state.filteredTasks);
        });
    }

    setSelectedTask (selectedIndex) {
        let selectedTask = this.state.filteredTasks[selectedIndex];
        // only one matches, set the state to that task and clear focus so the popup isn't annoying
        let text = this.props.showProject
                    ? "(" + selectedTask.projectName + ") " + selectedTask.name
                    : selectedTask.name;

        let selectedProject = null

        if (selectedTask.projectID) {
            selectedProject = {};
            selectedProject.id = selectedTask.projectID;
            selectedProject.name = selectedTask.projectName;
        }

        this.props.dispatch(taskActions.setSelectedTask(selectedTask));

        if (!this.props.onlyTask)
            this.props.dispatch(projectActions.setSelectedProject(selectedProject));
        if (this.props.handleSelect)
            this.props.handleSelect();

        this.setState({
            text: text,
            selectedUserTaskId: selectedTask.userTaskID,
            selectedUserQuota: selectedTask.userQuota,
            selectedTimeSpent: selectedTask.timeSpent,
            selectedProjectId: selectedTask.parent ? selectedTask.parent.id : null,
            scrollTop: 0,
            selectedIndex: selectedIndex,
            focused: false,
            forcePopup: false,
            filteredTasks: [selectedTask]
        });
    }

    setText = (text) => {
        this.setState({ text: text }
        , () => { this.filterTasks(text); });
    }

    // RENDER METHOD

    render = () => {
        return (
            <span>
                <input
                    className="form-control"
                    onBlur={this.handleBlur}
                    onChange={this.handleChange}
                    onClick={this.handleClick}
                    onFocus={this.handleFocus}
                    onKeyDown={this.handleKeyDown}
                    onKeyPress={this.handleKeyPress}
                    placeholder={this.props.placeholder}
                    ref="taskField"
                    title={this.state.text.length > 50 ? this.state.text : null}
                    type="text"
                    value={this.state.text}
                    />
                {
                    this.props.enableClear && this.state.text && this.state.text !== ''
                    ? <a style={{"cursor" : "pointer", "paddingRight" : "20px", "marginTop" : this.props.topOffset ? this.props.topOffset : "5px"}} onClick={this.clear} className="filter-clear">
                         <span><span className="md-clear"/></span>
                      </a>
                    : null
                }
                {
                    this.state.forcePopup && this.state.filteredTasks.length > 0
                    ?
                        (
                            //popup of task to select
                            <ul className="popup" onScroll={this.handleScroll} style={{ "width": this.state.popupWidth + "px", "top": this.state.popupTop + "px", "left": this.state.popupLeft + "px" }} ref="popup" onClick={this.handleClick}>
                                {
                                    this.state.filteredTasks.map((task, i) => {
                                        let classNames = classnames({
                                            'popup-text': i != this.state.selectedIndex,
                                            'popup-text-selected': i === this.state.selectedIndex
                                        });

                                        if (!task) return null;

                                        return (<ListItemForTaskInput
                                                   classNames={classNames}
                                                   id={task.id}
                                                   index={i}
                                                   key={task.id}
                                                   mouseDown={this.handleMouseDown}
                                                   mouseOver={this.handleMouseOver}
                                                   oneline={this.props.oneline}
                                                   projectName={task.projectName}
                                                   ref={"item" + i}
                                                   taskName={task.name}
                                                   />);
                                    })
                                }
                            </ul>
                        )
                    : null
                }
            </span>
        );
    }
}

AutoTaskInput.propTypes = {
    autoFocus: PropTypes.bool,
    disableTab: PropTypes.bool,
    dispatch: PropTypes.func,
    enableClear: PropTypes.bool,
    forceInitialPopup: PropTypes.bool,
    fillTaskForLogEntry: PropTypes.object,
    filterByDate: PropTypes.object,
    keepAfterClick: PropTypes.bool,
    hideClosed: PropTypes.bool,
    hideArchived: PropTypes.bool,
    handleSelect: PropTypes.func,
    oneline: PropTypes.bool,
    onlyTask: PropTypes.bool,
    placeholder: PropTypes.string,
    isPmo: PropTypes.bool,
    selectedProject: PropTypes.object,
    selectedTask: PropTypes.object,
    showProject: PropTypes.bool,
    tasks: PropTypes.array,
    text: PropTypes.string,
    topOffset: PropTypes.string
};

AutoTaskInput.defaultProps = {
    forceInitialPopup: true,
    hideClosed: false,
    oneline: false,
};

const mapStateToProps = (state) => {
    return {
        selectedProject: state.projects.selectedProject,
        selectedTask: state.tasks.selectedTask
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutoTaskInput);



/** WEBPACK FOOTER **
 ** ./src/app/components/AutoTaskInput.js
 **/